import {
  HHBaseTable,
  HHChip,
  HHTypography,
} from '@hinge-health/react-component-library';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NumbersIcon from '@mui/icons-material/Numbers';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import { useEffect, useState } from 'react';
import {
  AvailableFileCategories,
  FileDetail,
  FileReqColumnFields,
} from './file-upload-types';

const DataTypesText: Record<string, string> = {
  int: 'Number',
  str: 'Text',
  float: 'Decimal',
  date: 'Date',
};

function getIconForDataType(value: string): JSX.Element | null {
  switch (value) {
    case 'Number':
      return <NumbersIcon sx={{ fontSize: 12, color: 'text.secondary' }} />;
    case 'Text':
      return <TextFieldsIcon sx={{ fontSize: 12, color: 'text.secondary' }} />;
    case 'Decimal':
      return <AttachMoneyIcon sx={{ fontSize: 12, color: 'text.secondary' }} />;
    case 'Date':
      return (
        <CalendarMonthIcon sx={{ fontSize: 12, color: 'text.secondary' }} />
      );
    default:
      return null;
  }
}

export const FileCategoryRequirements = ({
  availableFileDetails,
  selectedFileCategory,
}: {
  availableFileDetails: AvailableFileCategories;
  selectedFileCategory?: string;
}): JSX.Element | null => {
  const [rows, setRows] = useState<FileDetail[]>([]);

  useEffect(() => {
    if (selectedFileCategory && availableFileDetails?.[selectedFileCategory]) {
      setRows(
        availableFileDetails[selectedFileCategory].map(
          (detail: FileDetail, idx: number) => ({
            id: idx,
            [FileReqColumnFields.COLUMN_NAME]: detail.columnName,
            [FileReqColumnFields.DATA_TYPE]: DataTypesText[detail.datatype],
            [FileReqColumnFields.REQUIRED]: detail.required,
          }),
        ),
      );
    } else {
      setRows([]);
    }
  }, [selectedFileCategory, availableFileDetails]);

  return (
    <HHBaseTable
      bodyTypographyVariant="inherit"
      headerRowBottomBorder="1px solid rgba(0, 0, 0, 0.12)"
      bodyRowBorder={{
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      }}
      tableHeaders={[
        { value: 'Column Name', align: 'left' },
        { value: 'Data Type', align: 'left' },
        { value: 'Required', align: 'left' },
      ]}
      bodyContent={rows.map(row => ({
        columnName: {
          value: <span>{row[FileReqColumnFields.COLUMN_NAME]}</span>,
        },
        datatype: {
          value: (
            <span>
              {getIconForDataType(row[FileReqColumnFields.DATA_TYPE])}
              {row[FileReqColumnFields.DATA_TYPE]}
            </span>
          ),
        },
        required: {
          value: (
            <span
              style={{
                color: row[FileReqColumnFields.REQUIRED]
                  ? '#d32f2f'
                  : '#388e3c',
                fontWeight: 500,
              }}
            >
              <HHChip
                hhVariant="outlined"
                size="small"
                color={row[FileReqColumnFields.REQUIRED] ? 'error' : 'default'}
                label={
                  <HHTypography hhVariant="overline">
                    {row[FileReqColumnFields.REQUIRED]
                      ? 'Required'
                      : 'Optional'}
                  </HHTypography>
                }
              />
            </span>
          ),
        },
      }))}
    />
  );
};
